<template>
  <v-dialog v-model="dialog" persistent max-width="80%">
    <v-card>
      <v-card-title>Cargar Contrato Firmado</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <div class="text-subtitle-2">Nombre:</div>
            <div>{{ item && item.nombre }}</div>
          </v-col>
          <v-col cols="4">
            <div class="text-subtitle-2">Apellido paterno:</div>
            <div>{{ item && item.apellido_paterno }}</div>
          </v-col>
          <v-col cols="4">
            <div class="text-subtitle-2">Apellido materno:</div>
            <div>{{ item && item.apellido_materno }}</div>
          </v-col>
          <v-col cols="6">
            <div class="text-subtitle-2">Puesto:</div>
            <div>{{ item && item.nombre_puesto }}</div>
          </v-col>
          <v-col cols="6">
            <div class="text-subtitle-2">Periodo:</div>
            <div>{{ periodo }}</div>
          </v-col>
          <v-col cols="12">
            <v-file-input
              v-model="contrato"
              label="Contrato"
              counter
              show-size
              dense
              hide-details
              outlined
              :truncate-length="50"
              clearable
              accept=".pdf"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="green" text :disabled="guardando" @click="cerrar">Cerrar</v-btn>
        <v-btn color="red" text :loading="guardando" :disabled="guardando" @click="cargar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-alert-dialog ref="alert" />
  </v-dialog>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue'

export default {
  components: { VAlertDialog },
  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null }
  },
  data: () => ({
    contrato: null,
    guardando: false
  }),
  computed: {
    dialog: {
      get() { return this.value },
      set(value) { this.$emit('input', value) }
    },
    periodo() {
      if (!this.item) return '-'
      const desde = this.item.fecha_desde || this.item.desde_puesto || '-'
      const hasta = this.item.fecha_hasta || this.item.hasta_puesto || 'Vigente'
      return `${desde} a ${hasta}`
    }
  },
  watch: {
    value(abierto) {
      if (abierto) this.contrato = null
    }
  },
  methods: {
    cerrar() {
      this.contrato = null
      this.dialog = false
    },
    async cargar() {
      if (!this.contrato) {
        this.mostrarAlerta('Debe seleccionar el contrato en formato PDF')
        return
      }
      if (!/\.pdf$/i.test(this.contrato.name || '')) {
        this.mostrarAlerta('Solo se aceptan archivos PDF.')
        return
      }

      const formData = new FormData()
      formData.append('id_empleado_puesto', this.item.id_empleado_puesto)
      formData.append('contrato', this.contrato)
      this.guardando = true
      try {
        await axios.post('/RecursosHumanos/CargarContratoFirmado', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        this.$emit('uploaded', this.item)
        this.cerrar()
      } catch (error) {
        const data = error && error.response && error.response.data
        this.mostrarAlerta((data && (data.msg || data.message)) || 'No se pudo cargar el contrato firmado.')
      } finally {
        this.guardando = false
      }
    },
    mostrarAlerta(message) {
      this.$refs.alert.setMessage('', message)
      this.$refs.alert.open()
    }
  }
}
</script>
